<!--  -->
<template>
<div class='map'>

    <div :class="['map_container',{'m':isMobile}]">
        <span :class="['close',{'m':isMobile}]" @click="close"><img src="@/assets/images/close-icon.png" alt=""></span>
        <div id="mapC"></div>
    </div>
</div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import browser from '@/utils/browser.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    isMobile:browser.mobile,
};
},
props:{
    show: Boolean
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {
show(val) {
        if(val) {
            this.getMap();
        }
    }
},
//方法集合
methods: {
    close() {
        this.$emit('close')
    },
    getMap() {
            var map = new window.BMapGL.Map("mapC"); // 创建地图实例 
            var point = new window.BMapGL.Point(112.607887,32.99874); // 创建点坐标 

            map.centerAndZoom(point, 15); //如果地图开始隐藏状态，会默认宽高为0，所以会在左上角；
            var loadCount = 1;
            map.addEventListener("tilesloaded", function () {
                if (loadCount == 1) {
                    map.centerAndZoom(point, 15);
                }
                loadCount = loadCount + 1;
            });

            map.enableScrollWheelZoom(true);
            var myIcon = new window.BMapGL.Icon("img/museum.png", new window.BMapGL.Size(40, 40));
            var marker = new window.BMapGL.Marker(point, {
                icon: myIcon
            }); // 创建标注
            map.addOverlay(marker);
            var opts = {
                width: 250, // 信息窗口宽度
                height: 100, // 信息窗口高度
                title: "南阳市博物馆" // 信息窗口标题
            }
            var content = `<p><span>地址：</span>南阳市宛城区姜营鼎盛大道369号</p> <p><span>电话：</span>(0377)60136336</p>`;
            var infoWindow = new window.BMapGL.InfoWindow(content, opts); // 创建信息窗口对象
            map.openInfoWindow(infoWindow, point);
            marker.addEventListener("click", function () {
                map.openInfoWindow(infoWindow, point); //开启信息窗口
            });
        }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

    
},
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    .map {
        position:fixed;
        width:100%;
        height:100%;
        background:rgba(0,0,0,0.2);
        .map_container {
            position:absolute;
            left:0;
            right:0;
            bottom:0;
            top:0;
            margin:auto;
            width:52vw;
            height:31.25vw;
            border-radius:10px;
            border:2px solid #e1b265;
            &.m {
                width:90vw;
                height:70vh;
                border-radius:10px;
                #mapC {
                    border-radius:10px;
                }
            }
            #mapC {
                position:absolute;
                left:0;
                right:0;
                top:0;
                bottom:0;
                margin:auto;
            }
            .close {
                position:absolute;
                display:block;
                width:2vw;
                top:-1vw;
                right:-1vw;
                z-index:2;
                &.m {
                width:8.5vw;
                bottom:-16vw;
                left:0;
                right:0;
                top:auto;
                margin:auto;
                }
            }
        }
    }
</style>